import { UseDurationScheduleReturn } from './useDurationSchedule';
import { UseRecurrenceReturn } from './useRecurrence';
import { UseDirtyStateTrackingReturn } from './useDirtyStateTracking';

interface UseAppointmentFormResetProps {
  durationSchedule: UseDurationScheduleReturn;
  recurrence: UseRecurrenceReturn;
  dirtyTracking: UseDirtyStateTrackingReturn;
  onPatientReset?: () => void;
  onAdditionalReset?: () => void;
}

/**
 * Hook to handle standardized form reset for appointment forms
 */
export const useAppointmentFormReset = ({
  durationSchedule,
  recurrence,
  dirtyTracking,
  onPatientReset,
  onAdditionalReset,
}: UseAppointmentFormResetProps) => {
  const resetForm = () => {
    // Reset duration schedule
    durationSchedule.setDate('');
    durationSchedule.setSelectedDuration(30);
    durationSchedule.setIsCustomDuration(false);
    durationSchedule.setStartTime('');
    durationSchedule.setEndTime('');

    // Reset recurrence
    recurrence.setRecurrence('none');
    recurrence.setRecurrenceEndDate('');
    recurrence.setHasRecurrenceEnd(false);
    recurrence.setRecurrenceCount(null);

    // Reset dirty state
    dirtyTracking.resetDirtyState();

    // Call additional reset handlers
    if (onPatientReset) {
      onPatientReset();
    }

    if (onAdditionalReset) {
      onAdditionalReset();
    }
  };

  return {
    resetForm,
  };
};
